import React from 'react';
import { Button } from 'antd';
import { SyncOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const CodeResetButton = ({ theme, codeReset }) => {
  const { t } = useTranslation('common');

  return (
    <Button
      onClick={codeReset}
      title={t('editor.reset_code_tooltip')}
      style={{
        margin: '0 0 0 8px',
        border: 'none',
        textDecoration: 'underline',
        background: 'none',
        color: theme === 'vs-dark' ? '#fff' : '#1890FF',
      }}
    >
      <SyncOutlined /> {t('editor.reset_button_label')}
    </Button>
  );
};

export default CodeResetButton;
